window.addEventListener('DOMContentLoaded', () => {

    const menu = document.querySelector('.left-navmenu')
    menu.addEventListener("mouseover", function(e) {
        let target = e.target.closest('.left-navmenu-item')
        target.classList.add('open-submenu')
    });
	menu.addEventListener("mouseout", function(e) {
        let target = e.target.closest('.left-navmenu-item')
        target.classList.remove('open-submenu')
    });

	const mobileBtns = document.querySelectorAll('.left-menu-navmenu-button')
    for ( let btn of mobileBtns ){
      
    	btn.addEventListener("click", function() {
			let parent = btn.closest('.left-navmenu-item')
            //console.log(parent)
            parent.classList.toggle('open-mobile-submenu')
        });
    }
    
});
